import { render } from "./gbarTrain.vue?vue&type=template&id=2bab287c&scoped=true"
import script from "./gbarTrain.vue?vue&type=script&lang=js"
export * from "./gbarTrain.vue?vue&type=script&lang=js"

import "./gbarTrain.vue?vue&type=style&index=0&id=2bab287c&scoped=true&lang=css"

import exportComponent from "/Users/tony/argon2/vue-argon-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bab287c"]])

export default __exports__